import { Text } from '@chakra-ui/react';

export const SubmitErrorComponent = (props: any) => {
   return <Text className="formManagerStatus">{props.error}</Text>;
};
